import styled from 'styled-components';
import HappyDoubleArrowSvg from './happyDoubleArrow.svg';

const HappyDoubleArrowIcon = styled(
  HappyDoubleArrowSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  margin: ${props => props.margin};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.base};

  transform: rotate(-270deg);
`;

export default HappyDoubleArrowIcon;
